import React from 'react';

interface EmptyStateProps {
  icon?: string;
  message: string;
  iconColor?: string;
  iconSize?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon = 'fas fa-inbox',
  message,
  iconColor = '#ffc3cc',
  iconSize = '0.75rem'
}) => (
    <div className="text-center py-4">
      <div>
        <i
          className={`${icon} mr-2`}
          style={{ fontSize: iconSize, color: iconColor }}
        />
        <strong>{message}</strong>
      </div>
    </div>
  );

export default EmptyState;